module.exports = __webpack_public_path__ + "static/media/InProgress.eb3b17a7.png";